import React from 'react';
import Footer from './Footer';

export default function AboutUs() {
  return (
    <div className="content-page">
      <div className="content-container">
        <div className="content-hero">
          <h1>About Canopy Biosystems Inc</h1>
          <p className="page-subtitle">Advancing plant care through precision sensing technology</p>
        </div>

        <div className="content-section">
          <h2>Our Mission</h2>
          <p>
            We believe that accurate, real-time plant stress data empowers better decision-making in 
            horticulture and agriculture. Our dendrometer sensors measure plant diameter changes to 
            provide early warning of water stress, helping users maintain healthier plants while 
            reducing unnecessary water consumption.
          </p>
          <p>
            At Canopy Biosystems, we're committed to bridging the gap between scientific precision 
            and practical plant care. Every measurement counts.
          </p>
        </div>

        <div className="content-section">
          <h2>Our Technology</h2>
          <p>
            Our platform combines precision sensing hardware with intelligent analytics to give users 
            clear visibility into their plants' daily cycles, stress levels, and overall wellbeing.
          </p>
          <p>
            The dendrometer sensors we've developed measure microscopic changes in plant stem diameter—
            changes that reveal a plant's physiological state with remarkable accuracy. By continuously 
            monitoring these changes, our system can detect water stress days before visible wilting occurs.
          </p>
          <ul>
            <li><strong>Real-time Monitoring:</strong> 15-minute resolution data captures your plants' daily rhythms</li>
            <li><strong>Early Detection:</strong> Identify stress before it causes damage</li>
            <li><strong>Smart Analytics:</strong> AI-powered insights into plant health trends</li>
            <li><strong>Resource Optimization:</strong> Water more efficiently with data-driven decisions</li>
          </ul>
        </div>
      </div>

      <Footer />
    </div>
  );
}
